import reducer from "./reducer";
export { default as RequestedDocuments } from "./components/index";
export { default as requestedDocumentsReducerName } from "./constants";
export default reducer;
